import './common.js';
import './my-jichica.js';
import './weather.js';
import './jichica-tab-notifier.js';
import './rarea_list.js';
import './survey.js';
import './member-control.js';